import moment from 'moment';
import { Badge, Button } from 'reactstrap';
import isAuthorized from '../../../../helpers/isAuthorized';

export const getNewHireColumns = (
  setSelectedNewHire: (_: any) => void,
  setNewHireReviewShow: (_: any) => void,
  handleApproveOrDeny: (e: React.FormEvent, action: string, id: string) => void,
  user: any,
  onOpenChat?: (id: string) => void,
) => {
  return [
    {
      name: 'Date',
      selector: (row: any) => row.createdAt,
      sortable: true,
      format: (row: any) => (row.createdAt ? moment(row.createdAt).format('MM/DD/YYYY') : '-'),
      width: '120px',
    },
    {
      name: 'Full Name',
      selector: (row: any) => `${row?.user?.firstName} ${row?.user?.lastName}`,
      sortable: true,
      width: '150px',
    },
    {
      name: 'Job Title',
      selector: (row: any) => row?.title?.name || '-',
      sortable: true,
      width: '120px',
    },
    {
      name: 'Department',
      selector: (row: any) => row?.department?.name || '-',
      sortable: true,
      width: '150px',
    },
    {
      name: 'Pay Rate',
      selector: (row: any) => row.payRate,
      sortable: true,
      cell: (row: any) =>
        `$${Number(row.payRate || 0).toFixed(2)} ${row?.paymentFrequency === 'hourly' ? '/ hour' : '/ year'}`,
      width: '150px',
      right: true,
    },
    {
      name: 'Start Date',
      selector: (row: any) => row.startDate,
      sortable: true,
      format: (row: any) => (row.startDate ? moment(row.startDate).format('MM/DD/YYYY') : '-'),
      width: '150px',
    },
    {
      name: 'Status',
      selector: (row: any) => row.status,
      sortable: true,
      cell: (row: any) => {
        return (
          <Badge
            color=""
            className="badge-dot badge-lg"
            style={{ fontSize: '0.8125rem', verticalAlign: 'middle', lineHeight: 'normal' }}
          >
            <i className={`bg-purple mr-2`} style={{ verticalAlign: 'baseline' }} />
            {String(row.status)?.replace('_', ' ')?.toUpperCase()}
          </Badge>
        );
      },
      width: '130px',
      center: true,
    },
    {
      name: 'Actions',
      cell: (row: any) => (
        <div className="d-flex justify-content-center">
          <Button
            outline
            color="info"
            size="sm"
            style={{ padding: '0.1rem 0.4rem', border: 'none' }}
            title="View Details"
            onClick={() => {
              setSelectedNewHire(row);
              setNewHireReviewShow(true);
            }}
          >
            <i className="fas fa-eye" />
          </Button>
          {onOpenChat && (
            <Button
              outline
              color="secondary"
              size="sm"
              style={{ padding: '0.1rem 0.4rem', border: 'none' }}
              title="Chat"
              onClick={() => onOpenChat(row?.id)}
            >
              <i className="fas fa-comment" />
            </Button>
          )}
          {isAuthorized({ moduleName: 'Employee', functionName: 'AdminApprove' }, user) && (
            <Button
              outline
              color="success"
              size="sm"
              style={{ padding: '0.1rem 0.4rem', border: 'none' }}
              title="Approve"
              onClick={(e: any) => {
                handleApproveOrDeny(e, 'approve', row?.id);
              }}
            >
              <i className="fas fa-check" />
            </Button>
          )}
          {isAuthorized({ moduleName: 'EmployeeNewHire', functionName: 'Revoke' }, user) && (
            <Button
              outline
              color="danger"
              size="sm"
              style={{ padding: '0.1rem 0.4rem', border: 'none' }}
              title="Deny"
              onClick={(e: any) => {
                handleApproveOrDeny(e, 'deny', row?.id);
              }}
            >
              <i className="fas fa-times" />
            </Button>
          )}
        </div>
      ),
      width: '150px',
      center: true,
    },
  ];
};
